import { ReactNode } from 'react';

import PropTypes from 'prop-types';

import { getErrorLogEntry } from '../../../util/helper';

import useEffect from '../../../util/hook/useEffect';
import useSelector from '../../../util/hook/useSelector';

import { selectLiffId, selectLogSessionToken } from '../../../util/redux/auth';

import { entryAPI } from '../../../api/log/entry';

import { S } from './style';

import errorImg from '../../../asset/image/error.svg';

import ConfigHeader from '../../helper/ConfigHeader';

/* Send logs to record the caught error */
const useLogError = ({
  _id,
  logSessionToken,
  level,
  msg,
  payload,
}: {
  _id: string;
  logSessionToken: string;
  level: string;
  msg: string;
  payload: any;
}) => {
  useEffect(() => {
    if (logSessionToken) {
      entryAPI.Post({
        _id,
        sessionToken: logSessionToken,
        log: {
          level,
          msg,
          payload,
        },
      });
    }
  }, []);
};

/**
 *
 * @param {object} error - The caught error
 * @returns {React.ReactElement} The default error fallback component to render on the screen
 */
export default function ErrorFallback({
  error,
}: {
  error: Error;
}): ReactNode {
  const _id = useSelector(selectLiffId);
  const logSessionToken = useSelector(selectLogSessionToken);
  const { level, msg, payload } = getErrorLogEntry(error);

  useLogError({ _id, logSessionToken, level, msg, payload });

  return (
    <S.Wrapper>
      <ConfigHeader />
      <S.Content>
        <S.Img src={errorImg} alt='error' />
        <S.Title>
          糟糕！
          <br />
          系統似乎出了點問題
        </S.Title>
        <S.Text>您可以將此畫面截圖傳送至Home心官方LINE客服，我們會盡速協助您。</S.Text>
        <S.Message>{`錯誤：${error.message}`}</S.Message>
      </S.Content>
      {/* 直接帶入 LINE 網址 */}
      <S.Button href="https://lin.ee/pCKOWQq">聯絡客服</S.Button>
    </S.Wrapper>
  );
}

ErrorFallback.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
};